<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 表单查询 -->
    <div class="bg-white pd-5">
      <el-form :inline="true" ref="form" :model="form" label-width="100px">
        <el-form-item label="设备编号">
          <el-input
            v-model="form.equipmentNum"
            clearable
            placeholder="请输入设备编号"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="所属企业">
          <el-select v-model="form.guishu" placeholder="全部" clearable>
            <el-option
              v-for="(v, i) in guishuqiye"
              :key="i"
              :label="v.companyName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="预警状态">
          <el-select v-model="form.state" placeholder="全部" clearable>
            <el-option label="待跟进" value="0"></el-option>
            <el-option label="已跟进" value="1"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="所属分区">
          <el-select
            filterable
            v-model="form.fenqu"
            placeholder="全部"
            clearable
          >
            <el-option
              v-for="(v, i) in zoneArr"
              :key="i"
              :label="v.regionName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="预警时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="
              getList();
              getStat();
            "
            >查询</el-button
          >
          <el-button
            @click="
              form = { startTime: '', endTime: '' };
              getList();
              getStat();
            "
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <!-- 统计 -->
    <div class="flex aic mgt-20 mgb-20">
      <span class="mgr-50"
        >合计预警数：{{ statForm.countNum ? statForm.countNum : 0 }}</span
      >
      <span class="mgr-50"
        >待跟进：{{
          statForm.unfinishedCount ? statForm.unfinishedCount : 0
        }}</span
      >
      <span
        >已跟进：{{ statForm.finishedCount ? statForm.finishedCount : 0 }}</span
      >
    </div>

    <el-table :data="tableData" border stripe style="width: 100%">
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="equipmentNum" label="设备编号"> </el-table-column>
      <el-table-column prop="name" label="设备名称"> </el-table-column>
      <!-- <el-table-column prop="companyName" label="设备归属"> </el-table-column> -->
      <el-table-column prop="regionName" label="所属分区"> </el-table-column>
      <el-table-column prop="place" label="铺设位置"> </el-table-column>
      <el-table-column prop="filterName" label="滤芯名称"> </el-table-column>
      <el-table-column prop="warningValue" label="预警余量(%)">
      </el-table-column>
      <el-table-column prop="createTime" label="预警时间"> </el-table-column>
      <el-table-column prop="updateTime" label="更换时间">
        <template slot-scope="scope">
          <span
            v-text="scope.row.updateTime ? scope.row.updateTime : '- -'"
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="预警状态">
        <template slot-scope="scope">
          <span v-text="scope.row.status == 0 ? '待跟进' : '已跟进'"></span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <!-- <el-button
            type="text"
            size="small"
            v-if="scope.row.status == 0"
            @click="handleCheck(scope.row)"
            >跟进</el-button
          > -->
          <el-button type="text" size="small" @click="handleDetail(scope.row)"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>
    <!-- 跟进弹框 -->
    <el-dialog
      title="跟进"
      :visible.sync="dialogVisible"
      width="30%"
      center
      top="30vh"
      :close-on-click-modal="false"
    >
      <el-form
        :rules="rules"
        ref="fllowForm"
        :model="fllowForm"
        label-width="80px"
      >
        <el-form-item label="跟进人员" prop="people">
          <el-input
            v-model="fllowForm.people"
            placeholder="请输入跟进人员"
          ></el-input>
        </el-form-item>
        <el-form-item label="跟进时间" prop="time">
          <el-date-picker
            style="width: 100%;"
            v-model="fllowForm.time"
            format="yyyy-MM-dd"
            type="date"
            placeholder="请选择跟进时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="跟进备注" prop="desc">
          <el-input
            type="textarea"
            v-model="fllowForm.desc"
            placeholder="请输入跟进备注"
            maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="图片" prop="photoDesc">
          <el-upload
            ref="upload"
            action="#"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-change="handleEditChange"
            :file-list="imgList"
            :http-request="uploadFile"
            :limit="3"
            :auto-upload="true"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="imgsVisible">
            <img width="100%" :src="fllowForm.photoDesc" alt="" />
          </el-dialog>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="dialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="sure('fllowForm')">跟 进</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import store from "../../store";

import { handleConfirm, handleAlert } from "../../components/UtilsIf";
export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      imgsVisible: false,
      imgList: [],
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      form: {},
      guishuqiye: [],
      zoneArr: [],
      tableData: [{ name: "" }],
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 15, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      dialogVisible: false,
      fllowForm: {
        people: "",
        time: "",
        desc: "",
        photoDesc: "",
      },
      rules: {
        people: [
          { required: true, message: "请输入跟进人员", trigger: "blur" },
        ],
        desc: [{ required: true, message: "请输入跟进备注", trigger: "blur" }],
        time: [{ required: true, message: "请选择跟进时间", trigger: "blur" }],
        photoDesc: [
          { required: true, message: "请上传跟进图片", trigger: "blur" },
        ],
      },
      id: null,
      statForm: {
        countNum: 0,
        finishedCount: 0,
        unfinishedCount: 0,
      },
      companyId: null,
    };
  },

  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },
  },
  created() {
    this.getROLE();
    // this.getGuishu();
    this.getZone();
    this.getList();
    this.getStat();
  },
  methods: {
    getROLE() {
      var token = store.getters.get_token;
      if (token) {
        this.companyId = token.companyId;
      }
    },
    sure(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          handleConfirm("确认跟进吗?", "info")
            .then(() => {
              let imgArr = [];
              this.imgList.forEach((v) => {
                imgArr.push(v.url);
              });
              var img = imgArr.join(",");
              this.$api.shebei
                .filterEarlyCheck({
                  addUserName: this.fllowForm.people,
                  updateTime: this.fllowForm.time,
                  remark: this.fllowForm.desc,
                  followPhoto: img,
                  id: this.id,
                })
                .then((res) => {
                  if (res.code === 200) {
                    handleAlert("跟进成功", "success");
                    this.getList();
                    this.dialogVisible = false;
                  }
                });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },
    handleCheck(row) {
      this.id = row.id;
      this.fllowForm = {
        people: "",
        time: "",
        desc: "",
        photoDesc: "",
      };
      this.imgList = [];
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.fllowForm.clearValidate();
      });
      this.dialogVisible = true;
    },
    handleDetail(row) {
      this.$router.push({
        path: "/shebei/filterEarly/datail",
        query: {
          data: row,
        },
      });
    },
    getStat() {
      this.$api.shebei
        .filterStat({
          companyId: this.companyId,
          regionId: this.form.fenqu,
          equipmentNum: this.form.equipmentNum,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
          status: this.form.state,
        })
        .then((res) => {
          if (res.code === 200) {
            this.statForm = res.data;
          }
        });
    },
    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.shebei
        .filterEarlyList({
          pageNum: this.page,
          pageSize: this.pageSize,
          companyId: this.companyId,

          regionId: this.form.fenqu,
          equipmentNum: this.form.equipmentNum,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
          status: this.form.state,
        })
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          }
        });
    },
    getGuishu() {
      this.$api.enterprise.enterpriseListPullNew().then((res) => {
        this.guishuqiye = res.data;
      });
    },
    getZone() {
      this.$api.marketing.allZonePull().then((res) => {
        if (res.code === 200) {
          this.zoneArr = res.data;
        }
      });
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page);
    },
    // 照片上传
    // 凭证图片上传------
    handlePictureCardPreview(file) {
      this.fllowForm.photoDesc = file.url;
      console.log(this.refundForm.photoDesc, "this.refundForm.photoDesc");
      this.imgsVisible = true;
    },
    handleRemove(file, fileList) {
      this.imgList = fileList;
    },
    /* 自定义上传 */
    uploadFile(params) {
      // 通过 FormData 对象上传文件
      let formData = new FormData();
      formData.append("files", params.file);

      /* 在这里发请求就行了 */
      /* ------------------------------------ */
      this.$api.shebei.uploadHeader(formData).then((res) => {
        if (res.code === 200) {
          this.fllowForm.photoDesc = res.data[0];
          this.imgList.push({
            url: res.data[0],
          });
        }
      });
      /* ------------------------------------ */

      // // 成功失败都删除文件;
      // this.fileList.splice(-1, 1);
    },
    // 图片超出张数不显示上传框
    handleEditChange(file, fileList) {
      console.log(fileList, "fileList");
      console.log(this.limitCount, "this.limitCount");
    },
  },
};
</script>

<style lang="scss" scoped></style>
